import SuperRepository from '../superRepository'

export default new class CampaingRepository extends SuperRepository {
  baseUri() {
    return 'campaign_queue'
  }
}